module.exports = __webpack_public_path__ + "img/Not just roads.b35821c5.jpg";